/**
 * 微信H5设置页面标题
 * @param {string} title - 要设置的页面标题
 */
export const setWechatTitle = (title) => {
  if (!title) return;
  
  // 普通浏览器设置标题
  document.title = title;
  
  // 微信环境下特殊处理
  if (/MicroMessenger/i.test(navigator.userAgent)) {
    const iframe = document.createElement('iframe');
    iframe.src = '/favicon.ico';
    iframe.style.display = 'none';
    iframe.onload = () => {
      setTimeout(() => {
        document.body.removeChild(iframe);
      }, 0);
    };
    document.body.appendChild(iframe);
  }
};
